"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import type { OrganizationRanking } from "../api/organizations";
import { OrganizationRankingRow } from "./organization-ranking-row";
import { OrganizationRankingRowMobile } from "./organization-ranking-row-mobile";
export function PublicRankingList(t0) {
  const $ = _c(22);
  const {
    rows,
    firstRank: t1,
    isMobile: t2
  } = t0;
  const firstRank = t1 === undefined ? 0 : t1;
  const isMobile = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation();
  const Row = isMobile ? OrganizationRankingRowMobile : OrganizationRankingRow;
  let t3;
  if ($[0] !== firstRank || $[1] !== rows || $[2] !== t) {
    let t4;
    if ($[4] !== firstRank) {
      t4 = (ranking, index) => ({
        "@type": "ListItem",
        position: firstRank + index + 1,
        item: {
          "@type": "Organization",
          name: ranking.name
        }
      });
      $[4] = firstRank;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: t("organizations.ratings.title"),
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      numberOfItems: rows.length,
      itemListElement: rows.map(t4)
    };
    t3 = rows.length > 0 ? <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd).replace(/</g, "\\u003c")
    }} /> : null;
    $[0] = firstRank;
    $[1] = rows;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("organizations.ratings.title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isMobile ? "flex flex-col gap-2 py-1" : "";
  let t6;
  if ($[8] !== Row || $[9] !== firstRank || $[10] !== rows) {
    let t7;
    if ($[12] !== Row || $[13] !== firstRank) {
      t7 = (ranking_0, index_0) => <li key={ranking_0.organization_id}><Row rank={firstRank + index_0 + 1} ranking={ranking_0} /></li>;
      $[12] = Row;
      $[13] = firstRank;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t6 = rows.map(t7);
    $[8] = Row;
    $[9] = firstRank;
    $[10] = rows;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <ol aria-label={t4} className={t5}>{t6}</ol>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t7) {
    t8 = <>{t3}{t7}</>;
    $[19] = t3;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}